import { OnInit, Component, ViewChild } from "@angular/core";
import { WizardStep } from "../../../wizard/wizard.component";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import {
  AdmissionReceptionWizardService,
  AdmissionWizardService,
} from "../../../services/wizard/admission/admission.wizzard.service";
import { AdmissionMedicalOrder } from '../../../model/admission';
import { NotificationToastService } from "../../../services/notification-toast.service";
import { validateMedicalOrderEdit } from "../../../validators/medical-order-edit.validator";
import { MedicalOrderEditControlComponent } from "../../controls/medical-order/medical-order-edit/medical-order-edit-control.component";
import { MedicalAppointmentValidation } from "src/app/model/medical-appointment-validation";

@Component({
  selector: "app-admission-medical-order-component",
  templateUrl: "./admission-medical-order.component.html",
  styleUrls: ["./admission-medical-order.component.css"],
})
export class AdmissionMedicalOrderComponent implements OnInit, WizardStep {
  isInit: boolean;
  loading: boolean;
  loadingInit: boolean;
  formGroup: FormGroup;
  disabledValidationOnLine: boolean;
  @ViewChild("medicalOrderEdit", { static: false })
  medicalOrderEdit: MedicalOrderEditControlComponent;
  medicalAppointmentValidation: MedicalAppointmentValidation;

  constructor(
    private admissionWizardService: AdmissionWizardService,
    private notificationToastService: NotificationToastService,
    private formBuilder: FormBuilder
  ) {
    this.formGroup = this.formBuilder.group({
      MedicalOrderEdit: [null, [Validators.required, validateMedicalOrderEdit]],
    });

    this.formGroup.valueChanges.subscribe(() => {
      this.admissionWizardService.setAdmissionMedicalOrder(
        <AdmissionMedicalOrder>this.formGroup.getRawValue()
      );
    });
  }

  get isReadOnly(): boolean {
    return this.admissionWizardService.isReadOnly();
  }

  get validateOnLineRequired(): boolean {
    return (
      this.medicalOrderEdit.validateOnLineRequired &&
      !this.medicalAppointmentValidation &&
      !this.disabledValidationOnLine
    );
  }

  get isWizzard(): boolean {
    return this.admissionWizardService.isWizzard();
  }

  get valid(): boolean {
    return this.completed;
  }

  get completed(): boolean {
    return (
      !this.medicalOrderEdit.invalid &&
      (!this.medicalOrderEdit.validateOnLineRequired ||
        this.medicalAppointmentValidation) &&
      !this.formGroup.invalid
    );
  }

  save(): void {}

  async executeOnLineOperation() {
    try {

      this.medicalOrderEdit.validating = true;
      this.medicalAppointmentValidation =
        await this.admissionWizardService.executeOnLineOperation();

      if (
        this.medicalAppointmentValidation.Pending ||
        this.medicalAppointmentValidation.NoValidate ||
        this.medicalAppointmentValidation.PartialValidate
      ) {
        this.notificationToastService.error(
          this.medicalAppointmentValidation.DisplayMessage,
          "Validación on line"
        );
      } else {
        this.notificationToastService.success(
          this.medicalAppointmentValidation.DisplayMessage,
          "Validación on line"
        );
      }
    } catch (err) {
      this.medicalAppointmentValidation = new MedicalAppointmentValidation();
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Admisión",
        true
      );
    } finally {
      const medicalOrder = await this.admissionWizardService.getMedicalOrder();
      this.medicalOrderEdit.setValidationInfo(medicalOrder.MedicalOrderEdit);
      this.formGroup.patchValue({
        MedicalOrderEdit: medicalOrder.MedicalOrderEdit,
      });

      this.loading = false;
    }
  }

  async activate() {
    try {
      if (this.isInit) {
        this.loadingInit = true;

        const admissionMedicalOrder =
          await this.admissionWizardService.getMedicalOrder();
        this.disabledValidationOnLine =
          !this.admissionWizardService.isOrderInSector();
        admissionMedicalOrder.MedicalOrderEdit.MedicalOrder.PlanId =
          admissionMedicalOrder.MedicalOrderEdit.MedicalOrderEditInfo.PlanId;
        admissionMedicalOrder.MedicalOrderEdit.MedicalOrder.IncompleteMedicalOrderAmount =
          admissionMedicalOrder.MedicalOrderEdit.MedicalOrderEditInfo.IncompleteMedicalOrderAmount;
        admissionMedicalOrder.MedicalOrderEdit.MedicalOrder.MedicalOrderStateId =
          admissionMedicalOrder.MedicalOrderEdit.MedicalOrderEditInfo.MedicalOrderState.Id;
        admissionMedicalOrder.MedicalOrderEdit.MedicalOrder.PatientId =
          this.admissionWizardService.admission.PatientId;

        this.formGroup.patchValue({
          MedicalOrderEdit: admissionMedicalOrder.MedicalOrderEdit,
        });
        setTimeout(() => this.medicalOrderEdit.setFocus(), 0);
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Admisión"
      );
    } finally {
      this.loadingInit = false;
    }
  }

  ngOnInit(): void {
    this.isInit = true;
  }
}
